export enum EPaymentMethod {
    CASH = 1,
    CHECK = 2,
    ACCOUNT_CREDIT = 3,
    BANK_SLIP = 4,
    CREDIT_CARD = 5,
    DEBIT_CARD = 6,
    ONLINE_CARD = 7,
    ONLINE_BANK_SLIP = 8,
    TRANSFER = 9,
    DIRECT_DEBIT = 10,
    ACCOUNT_TRANSFER = 11,
    PIX = 12,
}

export enum EPaymentMethodType {
    RECEIVABLE = 1,
    PAYABLE = 2,
}

export enum ECreditCardBrand {
    VISA = 'visa',
    MASTERCARD = 'mastercard',
    AMERICAN_EXPRESS = 'american_express',
    ELO = 'elo',
    HIPERCARD = 'hipercard',
    HIPER = 'hiper',
    DISCOVER = 'discover',
    DINERS = 'diners',
    AURA = 'aura',
    JCB = 'jcb',
    CABAL = 'cabal',
    BANESCARD = 'banescard',

    UNKNOWN = 'unknown',
}
